import { render, staticRenderFns } from "./DateAlt.vue?vue&type=template&id=74d4bc2b&scoped=true&"
import script from "./DateAlt.vue?vue&type=script&lang=ts&"
export * from "./DateAlt.vue?vue&type=script&lang=ts&"
import style0 from "./DateAlt.vue?vue&type=style&index=0&id=74d4bc2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d4bc2b",
  null
  
)

export default component.exports